import React from 'react'
import * as UI from 'ui'
import { SquareButton, Table } from 'ui'
import {
  Collection,
  ExecuteOperationForModelOnPipe,
  ExecuteOperationOnPipe,
  WhenModelValue
} from '@morningtrain/react-resources'
import * as Columns from 'support/columns'
import { Translation, Translator } from '@morningtrain/react-translations'
import { PaginationFilter, StaticFilter } from '@morningtrain/react-filters'
import * as Icons from 'ui/icons'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'

export default function UserChangesView ({ userId = null, salaryPeriodId = null }) {
  return (
    <>
      <UI.CardHeader>
        <UI.SecondaryHeading>
          <Translation name="hr.user_changes.title"/>
        </UI.SecondaryHeading>
      </UI.CardHeader>
      <Collection resourceName="user_changes.user_changes">
        <StaticFilter name="user_id" value={userId}/>
        <StaticFilter name="salary_period_id" value={salaryPeriodId}/>
        <Table>
          <Translator namespace="hr.user_changes.columns">
            <Columns.DateTime name="created_at"/>
            <Columns.Text name="field"/>
            <Columns.Text name="old_value"/>
            <Columns.Text name="new_value"/>
            <Columns.Text name="changed_by_user.name"/>
            <Columns.Column alignment="right">
              <WhenModelValue name="read" condition={(read) => !!read === false}>
                <Pipeline>
                  <TriggerPipelineOnClick>
                    <ExecuteOperationForModelOnPipe operationName="mark_as_read"/>
                    <ExecuteOperationOnPipe operationName="index"/>
                    <SquareButton color="btn-lightgray">
                      <Icons.Eye className="w-4 h-4"/>
                    </SquareButton>
                  </TriggerPipelineOnClick>
                </Pipeline>
              </WhenModelValue>
            </Columns.Column>
          </Translator>
        </Table>
        <PaginationFilter/>
      </Collection>
    </>
  )
}
